import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewOrgPageLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewOrgPage" */
      './ViewOrgPage.dynamic'
    ),
  loading: LoadingPageLoadable,
});
